var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-switch',{attrs:{"disabled":_vm.disabled},on:{"change":_vm.handleChange},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})
}
var staticRenderFns = []

export { render, staticRenderFns }